<div class="tooltip-row">
  <div class="online badge badge_green badge_rounded">
    <span class="dot"></span>
    {{ chatService.onlineCount }}
  </div>
  <h6 class="chat-title">Chat</h6>
  <div class="buttons">
    <button class="settings button-icon" [toggleDropdown]="settings" [ngClass]="{ active: !settings.collapsed }">
      <app-icon class="icon" [width]="20" icon="gear" />
    </button>
    <app-dropdown class="settings-dropdown" [width]="216" #settings [maxHeight]="500" (onItemSelect)="onItemSelect($event)" [autoClose]="false">
      <app-dropdown-item class="red" [value]="'trivia'">
        <app-icon icon="trivia" />
        <p>Trivia</p>
      </app-dropdown-item>
      <app-dropdown-item class="red" [value]="'trivia-rain'">
        <app-icon icon="trivia" />
        <p>Trivia rain</p>
      </app-dropdown-item>
      <app-dropdown-item [value]="'battle-spin'">
        <app-icon icon="battle_spin" />
        <p>
          Battle spin: <span class="text-red">{{ uiService.wheelVersion === '2' ? 'Improved' : 'Classic' }}</span>
        </p>
      </app-dropdown-item>
      <app-dropdown-item [value]="'sound'">
        <app-icon icon="sound" />
        <p>Sound:</p>
        <span class="text-red">{{ uiService.volume > 0 ? 'Enabled' : 'Disabled' }}</span>
      </app-dropdown-item>
      <app-slider
        class="slider"
        [defaultValue]="uiService.volume * 100"
        [value]="uiService.volume * 100"
        (valueChange)="uiService.volume = $event / 100"
        [min]="0"
        [max]="100"
        [step]="1"
        [showValue]="false"
        (valueChange)="updateVolume($event)"
      ></app-slider>
      <app-dropdown-item [value]="'bet-notif'">
        <app-icon icon="notification" />
        <p>
          Bet notification: <span class="text-red">{{ notificationService.betNotifications ? 'Enabled' : 'Disabled' }}</span>
        </p>
      </app-dropdown-item>
    </app-dropdown>

    <button class="trim button-icon" (click)="uiService.toggleUIState('chat', isTrimmed() ? 'open' : 'trimmed')" [class.closed]="isTrimmed()">
      <app-icon class="icon" [width]="20" icon="collapse" />
    </button>
    <button class="hide button-icon" (click)="toggleChat()">
      <app-icon class="icon" [width]="15" [stroke_width]="1.66667" icon="cross" />
    </button>
  </div>
</div>
<div class="socials-buttons-wrapper">
  <div class="socials-lang">
    <div class="icons">
      <a href="https://twitter.com/skinbetgg" target="_blank" rel="noopener">
        <app-icon [icon]="'twitter'" [width]="16" [pathStroke]="'#f1e8e7'"></app-icon>
      </a>
      <a href="https://discord.gg/skinbetgg" target="_blank" rel="noopener">
        <app-icon [icon]="'discord'" [width]="20" [pathFill]="'#5865F2'"></app-icon>
      </a>
    </div>
    <!-- <div class="language-selector">
      <button class="lang-button" [toggleDropdown]="langDropdown" [ngClass]="{ active: !langDropdown.collapsed }">
        <img [src]="currentLang.flag" width="20" height="20" [alt]="currentLang.code.toUpperCase()" />
        <span>{{ currentLang.code.toUpperCase() }}</span>
      </button>
      <app-dropdown class="language-selector-dropdown" #langDropdown [width]="120" (onItemSelect)="onLanguageSelect($event)">
        @for(lang of languages; track lang.code) {
        <app-dropdown-item [value]="lang.code">
          <img [src]="lang.flag" width="20" height="20" [alt]="lang.code.toUpperCase()" />
          <span>{{ lang.name }}</span>
        </app-dropdown-item>
        }
      </app-dropdown>
    </div> -->
  </div>

  <div class="chat-rules">
    <button class="rules-button" [toggleDropdown]="rulesDropdown" [ngClass]="{ active: !rulesDropdown.collapsed }">
      <app-icon [icon]="'rules'" [width]="16" [pathStroke]="'#787676'"></app-icon>
    </button>
    <app-dropdown class="chat-rules-dropdown" #rulesDropdown [width]="300" [maxHeight]="400">
      <div class="rules-content">
        <h3>Chat Rules</h3>
        <ul class="rules-list">
          <li><strong>Respectful Behavior:</strong> Racism, harassment, or offensive language of any kind is strictly prohibited.</li>
          <li><strong>No Begging:</strong> Begging for skins, items, or services is not allowed.</li>
          <li><strong>Avoid Spamming:</strong> Spamming messages or repetitive behavior will result in a mute.</li>
          <li><strong>Technical Issues:</strong> If you encounter any technical issues, please contact support through the designated chat channels.</li>
          <li><strong>No Promotions:</strong> Affiliate codes, custom campaigns, and social media promotions are not allowed in the chat.</li>
        </ul>
      </div>
    </app-dropdown>
  </div>
</div>
